import styled from 'styled-components'
import { SkeletonCell as SkeletonCellBase } from 'components/skeleton'

export const Wrap = styled.div``

export const SkeletonCell = styled(SkeletonCellBase)`
    justify-content: center;
`